import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';

import _cloneDeep from 'lodash/fp/cloneDeep';

import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';
import intl from '../../../shared/intl';
import checkPermissions from '../../../shared/check-permissions';
import createTable from '../components/table';

const table = createTable({ namespace: 'achievementsList',  stateNodeName: 'table' });

const FETCH_DATA_SUCCESS = 'achievementsList/fetch-data-success';
const REMOVE_SUCCESS = 'achievementsList/remove-data-success';
const REQUEST_ERROR = 'achievementsList/request-error';
const TOGGLE_PROGRESS_BAR = 'achievementsList/toggle-progress-bar';

export const allowedPermissions = {
	'view': 'achievements_view',
	'edit': 'achievements_update'
};

const initialState = {
	data: null,
	showProgressBar: false,
	table: table.initialState,
	search: '',
	error: false
};

export const actions = Object.assign(
	{
		fetchData: props => (dispatch, getState) => {
			return http({
				url: endpoints.ACHIEVEMENTS.BASE,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, REQUEST_ERROR]
			})(dispatch);
		},

		remove: id => (dispatch, getState) => {
			return http({
				url: `${endpoints.ACHIEVEMENTS.SINGLE.replace('{id}', id)}`,
				method: 'delete',
				actions: [REMOVE_SUCCESS, REQUEST_ERROR]
			})(dispatch);
		},

		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		})

	},
	table.actions
);

const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			return {...initialState};
		},
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: action.payload.data,
			showProgressBar: false,
			error: false
		}),
		[REMOVE_SUCCESS]: (state, action) => ({
			...state, data: null
		}),
		[REQUEST_ERROR]: state => ({
			...state, showProgressBar: true
		}),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: true })
	},
	table.reducers,
);

export default handleActions(reducers, _cloneDeep(initialState));

export const selectors = {
	getData: state => state.achievementsList.data,
	getTable: table.selectors.getTable,
	getCan: state => checkPermissions(state, allowedPermissions),
	getIntl: state => intl(state),
	getProgressBar: state => state.achievementsList.showProgressBar,
	getError: state => state.achievementsList.error
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/missions/achievement/list/index.js